import React from 'react';
import { Box, Card, Typography } from '@mui/joy';

const StockMobileList = ({ empty, emptyMessage, children }) => (
  <Box
    sx={{
      display: { xs: 'flex', md: 'none' },
      flexDirection: 'column',
      gap: 1.5
    }}
  >
    {empty ? (
      <Card variant="outlined" sx={{ p: 3, textAlign: 'center' }}>
        <Typography level="body-md" sx={{ color: 'text.secondary' }}>
          {emptyMessage}
        </Typography>
      </Card>
    ) : (
      children
    )}
  </Box>
);

export default StockMobileList;
